import apiService from '../apiService'

const apiPath = '/titles'

export const titlesController = (configService) => {
	const service = apiService(configService)
	return {
		getTitleViriya: () => {
			return service.get({
				url: `${apiPath}/get_title_viriya`,
			})
		},
		getTitleIntra: () => {
			return service.get({
				url: `${apiPath}/get_title_intra`,
			})
		},
		getTitleThaisri: () => {
			return service.get({
				url: `${apiPath}/get_title_thaisri`,
			})
		},
		getTitleRvp: () => {
			return service.get({
				url: `${apiPath}/get_title_rvp`,
			})
		},
		getTitleDvs: () => {
			return service.get({
				url: `${apiPath}/get_title_dvs`,
			})
		},
	}
}
